const { createApp: createIngSingApp } = Vue;
function toLocaleString(value, locales, options) {
	if (!isNaN(value) && value !== null) {
		return value.toLocaleString(locales, options);
	}
	return value;
}

var app_single_ingredient = createIngSingApp({
  data() {
    return {
      all_ingredients: [],
      single_ingredient: null,
    }
  },
  computed: {
    has_all_ingredients() { return Array.isArray(this.all_ingredients) && this.all_ingredients.length },
    has_single_ingredient() { return this.single_ingredient && this.single_ingredient.handle },
    count_studies() {
      if(this.has_single_ingredient) {
        return toLocaleString(this.single_ingredient.number_of_studies, (window.navigator.language || 'en-GB'));
      }
      return 0;
    }
  },
  methods: {
    findIngredient() {
      if (this.has_all_ingredients) {
        let page_path = window.location.pathname
        let the_handle = ''
        let raw_handle = page_path.split('pages/ingredient-')
        if (raw_handle.length === 2) {
          the_handle = 'ingredient-' + raw_handle[1]
        }
        let selected_ingredient = this.all_ingredients.find(ingredient => ingredient.handle === the_handle)
        if (selected_ingredient) {
          this.single_ingredient = selected_ingredient
        }
        else {
          console.warn('Failed to find ingredient based on handle ', the_handle)
        }
      }
    },
  },
  mounted() {
    this.all_ingredients = effic_all_ingredients
    this.findIngredient()
  }
});

app_single_ingredient.mount('#app_single_ingredient');